import { useRef, useEffect } from 'react';

export default function useInitialValue(value) {
  const initialValue = useRef(value);

  useEffect(() => {
    initialValue.current = value;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return initialValue.current;
}
